import React from 'react';
import LeaderboardTable from './LeaderboardTable';

export interface ILeaderboardProps {
  title: string;
  stringHeader: string;
  numberHeader: string;
  data: Array<[string, number]>;
}

const Leaderboard: React.FC<ILeaderboardProps> = (props: ILeaderboardProps) => {
    return (
      <div className="Leaderboard">
        <p className="LeaderboardTitle">{props.title}</p>
        <LeaderboardTable
          stringHeader={props.stringHeader}
          numberHeader={props.numberHeader}
          data={props.data} />
      </div>
    );
  }
  
  export default Leaderboard;